import styled from 'styled-components';
import {
  classColor,
  groupColor,
  studentColor,
  STUDENT
} from '../../../../../helpers/utils';

import {
  flexDirection,
  flexbox,
  justifyContent
} from '../../../../../styles/helpers/flexbox';

const DoughnutsWrapper = styled.div(
  () => `
  position: relative;
  width: 250px;

  .doughnut-svg {
    position: relative;
    z-index: 10;
  }
`
);

const ClassroomIconWrapper = styled.div(
  (props) => `
  position: absolute
  top: ${props.type === STUDENT ? 50 : 42}px;
  width: 100%;
  text-align: center;
  z-index: 5;
`
);

const PercentWrapper = styled.div(
  (props) => `
  position: absolute;
  top: ${props.type === STUDENT ? 65 : 60}px;
  width: 100%;
  text-align: center;
  z-index: 6;
  font-size: ${props.type === STUDENT ? 24 : 34}px;
  font-weight: bold;
  letter-spacing: -1px;
`
);

const AttemptIconWrapper = styled.div`
  ${flexbox()};
  ${justifyContent('center')};

  position: absolute
  top: 94px;
  width: 100%;
  z-index: 5;
`;

const LegendWrapper = styled.div(
  (props) => `
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 12px;
  ${props.type === STUDENT ? flexDirection('column') : ''}

  .legend-shell {
    display: flex;
    align-items: center;
    flex: 1;
    user-select: none;

    .color-indi {
      width: 16px;
      height: 16px;
      border-radius: 15px;
    }
  
    .class {
      background-color: ${classColor};
    }
  
    .group {
      background-color: ${groupColor};
    }

    .student {
      background-color: ${studentColor};
    }

    div[class*='svgIconComponent--'] {
      width: 30px;
    }
`
);

export {
  DoughnutsWrapper,
  ClassroomIconWrapper,
  PercentWrapper,
  AttemptIconWrapper,
  LegendWrapper
};

export const ContextModalContent = styled.div`
  color: white;
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-chart.styled.js